import React from 'react';
import "./Footer.css";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <div className ="footer__box">
           <span>Email suggestions/comments to  <a href="mailto: docdatainc@gmail.com"> docdatainc </a>  &copy; <Link to="/setup1">2021</Link>
               </span>
            
        </div>
    )
}

export default Footer
